import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'

import Icon from '_components/icon'
import { subscribe, getProfileInfo } from '_modules/user/actions'

import { planTypeForValue, planTypes } from '_utils/planType'
import StripeBuy from './stripe-buy'
import styles from './styles.css'

const mapStateToProps = ({ user }) => ({
  user,
})

const mapDispatchToProps = {
  subscribe,
  getProfileInfo,
}

class Subscribe extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map,
    subscribe: PropTypes.func.isRequired,
    getProfileInfo: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
  }

  state = {}

  componentWillMount() {}

  onCheckboxChange = event => {
    const { name } = event.target

    this.setState({
      [name]: !this.state[name],
    })
  }

  onFieldChange = event => {
    const { name, value } = event.target

    this.setState({
      [name]: value,
    })
  }

  onToken = ({ plan, subscriptionType, planType, token, storeType }) => {
    this.props.subscribe({
      token,
      plan,
      subscriptionType,
      planType,
      storeType,
    })

    browserHistory.push('/')
  }

  render() {
    const { user } = this.props
    const planType = user.get('planType') || 100
    const email = user.get('email') || ''
    return (
      <div className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}>
        <div>
          <p>Current Subscription Plan: {planTypeForValue(planType)}</p>
        </div>
        <table className={classnames(styles.table)}>
          <colgroup>
            <col span="1" style={{ width: '40%' }} />
            <col span="1" style={{ width: '20%' }} className={classnames(styles.free)} />
            <col span="1" style={{ width: '20%' }} className={classnames(styles.pro)} />
            <col span="1" style={{ width: '20%' }} className={classnames(styles.team)} />
          </colgroup>
          <thead>
            <tr>
              <th>FEATURE</th>
              <th>FREE</th>
              <th>PRO</th>
              <th>TEAM</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td />
              <td />
              <td>$2.99/mo</td>
              <td>$5.99/mo</td>
            </tr>
            <tr>
              <td>Now Page</td>
              <Check />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Mindful Breaks</td>
              <Check />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Log Page</td>
              <Check />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Today Page</td>
              <td />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Capture Page</td>
              <td />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Mindful Breaks Reminders</td>
              <td />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Smart Notifications</td>
              <td />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Tracking Engagement and Reflections</td>
              <td />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Summary Report Analytics</td>
              <td />
              <Check />
              <Check />
            </tr>
            <tr>
              <td>Team Page</td>
              <td />
              <td />
              <Check />
            </tr>
            <tr>
              <td>Status Updates</td>
              <td />
              <td />
              <Check />
            </tr>
            <tr>
              <td />
              <td />
              <td>
                <StripeBuy
                  email={email}
                  plan="com-hmm-pro-monthly-299"
                  planType="PRO"
                  storeType="STRIPE"
                  subscriptionType="MONTHLY"
                  description="Pro - Monthly Subscription"
                  label="$2.99/mo"
                  amountCents={299}
                  onToken={this.onToken}
                  disabled={planType >= planTypes.pro}
                />
              </td>
              <td>
                <StripeBuy
                  email={email}
                  plan="com-hmm-team-monthly-599"
                  planType="TEAM"
                  storeType="STRIPE"
                  subscriptionType="MONTHLY"
                  description="Team - Monthly Subscription"
                  label="$5.99/mo"
                  amountCents={599}
                  onToken={this.onToken}
                  disabled={planType >= planTypes.team}
                />
              </td>
            </tr>
            <tr>
              <td />
              <td />
              <td>
                <StripeBuy
                  email={email}
                  plan="com-hmm-pro-yearly-2499"
                  planType="PRO"
                  storeType="STRIPE"
                  subscriptionType="YEARLY"
                  description="Pro - Yearly Subscription"
                  label="$24.99/yr"
                  amountCents={2499}
                  onToken={this.onToken}
                  disabled={planType >= planTypes.pro}
                />
              </td>
              <td>
                <StripeBuy
                  email={email}
                  plan="com-hmm-team-yearly-4999"
                  planType="TEAM"
                  storeType="STRIPE"
                  subscriptionType="YEARLY"
                  description="Team - Yearly Subscription"
                  label="$49.99/yr"
                  amountCents={4999}
                  onToken={this.onToken}
                  disabled={planType >= planTypes.team}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const Check = () => (
  <td style={{ fontSize: 14 }}>
    <Icon type="done" isButton={false} />
  </td>
)

export default connect(mapStateToProps, mapDispatchToProps)(Subscribe)



// WEBPACK FOOTER //
// ./src/views/subscribe/index.js